import uiActiveOfferModal from './modal/index.vue'

export {
    uiActiveOfferModal
}